import React from "react";
import { makeStyles, ButtonBase, useTheme, useMediaQuery } from "@material-ui/core";

import useProductValidator from "hooks/useProductValidator";
import useCart from "../../hooks/useCart";
import ShopIcon from "./assets/shopIcon.svg";
import CartOverlayDesktop from "./cartOverlay/CartOverlayDesktop";
import ShopButtonNotification from "./ShopButtonNofication";

function ShopButtonDesktop({ color }) {
  const classes = useStyle({ color });
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("sm"));
  const [, checkProductsAvailability] = useProductValidator();
  const [cart, dispatch] = useCart();
  const openCart = () => {
    checkProductsAvailability();
    dispatch({
      type: "open",
    });
  };

  // Don't render the overlay if we are on mobile to prevent interference between overlays
  if (!isTablet) {
    return (
      <div className={classes.shopContainer}>
        <ButtonBase onClick={openCart} className={classes.cartButton}>
          <ShopButtonNotification />
          <ShopIcon className={classes.icon} />
        </ButtonBase>
        {cart?.open && <CartOverlayDesktop />}
      </div>
    );
  }

  return null;
}

const useStyle = makeStyles((theme) => ({
  shopContainer: {
    position: "relative",
    marginRight: theme.spacing(2),
  },
  cartButton: {
    marginLeft: theme.spacing(2),
    transform: "translateY(0px)",
    transition: "transform 200ms",
    "&:hover": {
      transform: "translateY(-2px)",
    },
  },
  icon: {
    fill: ({ color }) => color || theme.palette.secondary.main,
    cursor: "pointer",
  },
}));

export default ShopButtonDesktop;
